@if (showMyself) {
  <div>
    <div class="lds-dual-ring"></div>
  </div>
}
